import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Heading, SelectDropDown } from 'components/common/Elements/Elements';
import FeatureItem from '../FeatureItem/FeatureItem';

import classes from './FeatureItems.module.scss';

const FeatureItems = ({
  title,
  data,
  options,
  valueOptions,
  onChangeOptions
}) => {
  return (
    <div className={classes.feature}>
      <Heading size={4} className={classes.feature_title}>
        {title}
      </Heading>

      {options && (
        <SelectDropDown
          clearable={false}
          className={classes.select}
          options={options}
          input={{ value: valueOptions, onChange: onChangeOptions }}
          isDisabled={options.length === 1}
        />
      )}
      <ul>
        {data.map(item => (
          <FeatureItem key={item.title} data={item} />
        ))}
      </ul>
    </div>
  );
};

FeatureItems.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(object),
  options: PropTypes.array,
  valueOptions: PropTypes.string,
  onChangeOptions: PropTypes.func
};

export default FeatureItems;
